import arrows from "../../../../../Assets/Images/arrows.svg";

const Table = ({ data }) => {
  return (
    <div className="pillar-table pillar-sec mx-auto mt-4">
      <div className="table-data table-responsive">
        <table className="table table-inr mb-0">
          <thead>
            <tr className="border-0">
              <th className="border-bottom-0 text-center">
                Dev Pillars
                <img
                  src={arrows}
                  alt="arrows"
                  style={{ height: "0.6rem", width: "0.6rem" }}
                  className="ms-2"
                />
              </th>
              <th className="border-bottom-0 text-center">
                Avg Score
                <img
                  src={arrows}
                  alt="arrows"
                  style={{ height: "0.6rem", width: "0.6rem" }}
                  className="ms-2"
                />
              </th>
              <th className="border-bottom-0 text-center border-end-0">
                % partcipation
                <img
                  src={arrows}
                  alt="arrows"
                  style={{ height: "0.6rem", width: "0.6rem" }}
                  className="ms-2"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item?.name}</td>
                  <td>{Math.ceil(item?.averageScore)}</td>
                  <td className="border-0">{Math.ceil(item?.participant)}%</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
